import React from 'react'
import { observer } from 'mobx-react-lite'

import { makeStyles } from '@material-ui/core/styles'

import { SyncErrorIcon } from './SyncErrorIcon'

import { tableCellStyles } from '../../hooks/tableStylesHook'

import { integrationNames, IntegrationTypeKey } from '../../types/integrationTypeUtils'

export type SingleProductSyncErrorProps = {
  type: IntegrationTypeKey

  product: {syncErrorId?: string} | undefined
}

export const SingleProductSyncError =
  observer(
    ({type, product}: SingleProductSyncErrorProps) => {
      const classes = useProductSyncErrorStyles()

      if (!product?.syncErrorId) {
        return null
      }

      return (
        <div className={classes.errorBlock}>
          <span>{integrationNames[type]}:</span>

          <SyncErrorIcon type={type} errorId={product.syncErrorId}/>
        </div>
      )
    })

export const useProductSyncErrorStyles =
  makeStyles(() => ({
    errorBlock: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      ...tableCellStyles.noWrap
    }
  }) as const)